// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5952) return "static/chunks/5952.e7882bc597d0dbed.js";
	if (chunkId === 3087) return "static/chunks/3087.687f5c6fb4dc6eae.js";
	if (chunkId === 4043) return "static/chunks/4043.0ff5369433ec428f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"996":"61be6194f416bc8a","5715":"c2e8fb955fb976be","8517":"8dc7294dbe618365","8532":"1456c10d7e3468c5","9664":"cf87fcda7d803fda"}[chunkId] + ".js";
};